module.exports = fox._r("images/blue-star.png", __webpack_public_path__ + "images/blue-star.png");


//////////////////
// WEBPACK FOOTER
// ./images/blue-star.png
// module id = 503
// module chunks = 2